import React from "react"
import { Filter, RefreshCw, Search } from "lucide-react"
import Button from "../common/Button.jsx"

export default function ManifestsFilters({
    showAllLocationsBadge = true,
    showCurrentYearFilter = false,
    currentYearLabel = "",
    searchTerm,
    onSearchTermChange,
    onSearchSubmit,
    onRefresh,
    onToggleAllLocations,
    onToggleCurrentYear,
    isAllLocations,
    isCurrentYear,
}) {
    return (
        <div className="mb-4 d-flex flex-column flex-lg-row gap-3 min-w-0">
            <form className="flex-grow-1 position-relative min-w-0" style={{ minWidth: 0 }} onSubmit={onSearchSubmit}>
                <Search
                    className="position-absolute text-secondary"
                    style={{
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                    }}
                    size={20}
                />
                <input
                    type="text"
                    placeholder="Search manifests..."
                    className="form-control ps-5"
                    style={{ paddingLeft: "2.5rem" }}
                    value={searchTerm}
                    onChange={(e) => onSearchTermChange(e.target.value)}
                />
            </form>
            <div className="d-flex flex-wrap gap-2">
                <Button variant="outline" size="sm" onClick={onRefresh}>
                    <span className="me-2"><RefreshCw size={16} /></span>
                    Refresh
                </Button>
                {showAllLocationsBadge ? (
                    <Button
                        variant={isAllLocations ? "secondary" : "outline"}
                        size="sm"
                        onClick={onToggleAllLocations}
                    >
                        <span className="me-2"><Filter size={16} /></span>
                        All locations
                    </Button>
                ) : null}
                {showCurrentYearFilter ? (
                    <Button
                        variant={isCurrentYear ? "secondary" : "outline"}
                        size="sm"
                        onClick={onToggleCurrentYear}
                    >
                        {currentYearLabel}
                    </Button>
                ) : null}
            </div>
        </div>
    )
}

